var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticStyle: { "background-color": "#F0F0EF" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pl-1 d-flex flex-column align-start",
              staticStyle: { padding: "0px", height: "42px" },
              attrs: { cols: "8", sm: "4" }
            },
            [
              _c("label", { staticClass: "font", attrs: { for: "label" } }, [
                _vm._v(_vm._s(_vm.$tc("Label")) + " *")
              ]),
              _vm._v(" "),
              _c("v-text-field", {
                staticStyle: { width: "184px" },
                attrs: {
                  value: _vm.receivedData.label,
                  color: "#4fa2b7",
                  clearable: "",
                  height: "25",
                  required: "",
                  rules: _vm.rules,
                  disabled: _vm.disableLabel
                },
                model: {
                  value: _vm.receivedData.label,
                  callback: function($$v) {
                    _vm.$set(_vm.receivedData, "label", $$v)
                  },
                  expression: "receivedData.label"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-column align-start",
              staticStyle: { padding: "0px" },
              attrs: { cols: "4", sm: "4" }
            },
            [
              _c("label", { staticClass: "font", attrs: { for: "label" } }, [
                _vm._v(_vm._s(_vm.$tc("Priority")) + " *")
              ]),
              _vm._v(" "),
              _c("v-autocomplete", {
                staticStyle: { width: "184px" },
                attrs: {
                  items: _vm.priorities,
                  height: "25",
                  color: "#4fa2b7",
                  "item-text": "label",
                  "item-value": "uuid",
                  "return-object": "",
                  rules: _vm.rules,
                  value: _vm.receivedData.priority,
                  disabled: _vm.disabledView,
                  onkeypress: "return false;"
                },
                model: {
                  value: _vm.receivedData.priority,
                  callback: function($$v) {
                    _vm.$set(_vm.receivedData, "priority", $$v)
                  },
                  expression: "receivedData.priority"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-column align-start",
              staticStyle: { padding: "0px" },
              attrs: { cols: "4", sm: "4" }
            },
            [
              _c("label", { staticClass: "font", attrs: { for: "label" } }, [
                _vm._v(_vm._s(_vm.$tc("ApprovalType")))
              ]),
              _vm._v(" "),
              _c("v-autocomplete", {
                staticStyle: { width: "184px" },
                attrs: {
                  items: _vm.approvalType,
                  height: "25",
                  color: "#4fa2b7",
                  value: _vm.automaticApproval,
                  "item-text": "title",
                  "item-value": "value",
                  disabled:
                    _vm.disabledView || _vm.selectedTemplates.length <= 0,
                  onkeypress: "return false;"
                },
                on: {
                  input: function($event) {
                    return _vm.setApproval($event)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "pl-1 d-flex flex-column align-start",
              staticStyle: { padding: "0px" },
              attrs: { cols: "8", sm: "4" }
            },
            [
              _c("label", { staticClass: "font", attrs: { for: "label" } }, [
                _vm._v(_vm._s(_vm.$tc("StartDate")) + " *")
              ]),
              _vm._v(" "),
              _c(
                "v-menu",
                {
                  ref: "menu",
                  attrs: {
                    "close-on-content-click": false,
                    "return-value": _vm.receivedData.start_date,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "auto"
                  },
                  on: {
                    "update:returnValue": function($event) {
                      return _vm.$set(_vm.receivedData, "start_date", $event)
                    },
                    "update:return-value": function($event) {
                      return _vm.$set(_vm.receivedData, "start_date", $event)
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              _vm._b(
                                {
                                  staticStyle: { width: "184px" },
                                  attrs: {
                                    color: "#4fa2b7",
                                    value: _vm.receivedData.start_date,
                                    "append-icon": "mdi-calendar",
                                    height: "25",
                                    rules: _vm.rules,
                                    clearable: "",
                                    disabled: _vm.disabledView,
                                    onkeypress: "return false;"
                                  },
                                  model: {
                                    value: _vm.receivedData.start_date,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.receivedData,
                                        "start_date",
                                        $$v
                                      )
                                    },
                                    expression: "receivedData.start_date"
                                  }
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              on
                            )
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.menu,
                    callback: function($$v) {
                      _vm.menu = $$v
                    },
                    expression: "menu"
                  }
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    attrs: {
                      "no-title": "",
                      scrollable: "",
                      min: _vm.disableDateBeforeStartDate,
                      max: _vm.disableDateAfterEndDate
                    },
                    on: {
                      input: function($event) {
                        return _vm.$refs.menu.save(_vm.receivedData.start_date)
                      }
                    },
                    model: {
                      value: _vm.receivedData.start_date,
                      callback: function($$v) {
                        _vm.$set(_vm.receivedData, "start_date", $$v)
                      },
                      expression: "receivedData.start_date"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-column align-start",
              staticStyle: { padding: "0px" },
              attrs: { cols: "8", sm: "4" }
            },
            [
              _c("label", { staticClass: "font", attrs: { for: "label" } }, [
                _vm._v(_vm._s(_vm.$tc("ExpectedEndDate")) + " *")
              ]),
              _vm._v(" "),
              _c(
                "v-menu",
                {
                  ref: "menu1",
                  attrs: {
                    "close-on-content-click": false,
                    "return-value": _vm.receivedData.end_date,
                    value: _vm.receivedData.end_date,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "auto"
                  },
                  on: {
                    "update:returnValue": function($event) {
                      return _vm.$set(_vm.receivedData, "end_date", $event)
                    },
                    "update:return-value": function($event) {
                      return _vm.$set(_vm.receivedData, "end_date", $event)
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              _vm._b(
                                {
                                  staticStyle: { width: "184px" },
                                  attrs: {
                                    "append-icon": "mdi-calendar",
                                    value: _vm.receivedData.end_date,
                                    height: "25",
                                    color: "#4fa2b7",
                                    rules: _vm.rules,
                                    clearable: "",
                                    disabled: _vm.disabledView,
                                    onkeypress: "return false;"
                                  },
                                  model: {
                                    value: _vm.receivedData.end_date,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.receivedData,
                                        "end_date",
                                        $$v
                                      )
                                    },
                                    expression: "receivedData.end_date"
                                  }
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              on
                            )
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.menu1,
                    callback: function($$v) {
                      _vm.menu1 = $$v
                    },
                    expression: "menu1"
                  }
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    attrs: {
                      "no-title": "",
                      scrollable: "",
                      "picker-date": _vm.dateStart,
                      min: _vm.disableDateBeforeStartDate
                    },
                    on: {
                      "update:pickerDate": function($event) {
                        _vm.dateStart = $event
                      },
                      "update:picker-date": function($event) {
                        _vm.dateStart = $event
                      },
                      input: function($event) {
                        return _vm.$refs.menu1.save(_vm.receivedData.end_date)
                      }
                    },
                    model: {
                      value: _vm.receivedData.end_date,
                      callback: function($$v) {
                        _vm.$set(_vm.receivedData, "end_date", $$v)
                      },
                      expression: "receivedData.end_date"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-column align-start",
              staticStyle: { padding: "0px" },
              attrs: { cols: "8", sm: "4" }
            },
            [
              _c("label", { staticClass: "font", attrs: { for: "label" } }, [
                _vm._v(_vm._s(_vm.$tc("FinishDate")))
              ]),
              _vm._v(" "),
              _c(
                "v-menu",
                {
                  ref: "menu2",
                  attrs: {
                    "close-on-content-click": false,
                    "return-value": _vm.receivedData.finishDate,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "auto"
                  },
                  on: {
                    "update:returnValue": function($event) {
                      return _vm.$set(_vm.receivedData, "finishDate", $event)
                    },
                    "update:return-value": function($event) {
                      return _vm.$set(_vm.receivedData, "finishDate", $event)
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              _vm._b(
                                {
                                  staticStyle: { width: "184px" },
                                  attrs: {
                                    "append-icon": "mdi-calendar",
                                    height: "25",
                                    color: "#4fa2b7",
                                    readonly: "",
                                    rules: _vm.rules,
                                    clearable: "",
                                    disabled: true
                                  },
                                  model: {
                                    value: _vm.receivedData.finishDate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.receivedData,
                                        "finishDate",
                                        $$v
                                      )
                                    },
                                    expression: "receivedData.finishDate"
                                  }
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              on
                            )
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.menu2,
                    callback: function($$v) {
                      _vm.menu2 = $$v
                    },
                    expression: "menu2"
                  }
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    attrs: { min: _vm.disableDateBeforeStartDate },
                    on: {
                      input: function($event) {
                        return _vm.$refs.menu2.save(_vm.receivedData.finishDate)
                      }
                    },
                    model: {
                      value: _vm.receivedData.finishDate,
                      callback: function($$v) {
                        _vm.$set(_vm.receivedData, "finishDate", $$v)
                      },
                      expression: "receivedData.finishDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider", { staticClass: "mt-4" }),
      _vm._v(" "),
      _c("work-order-detail-templates", {
        attrs: {
          receivedData: _vm.receivedData,
          "action-type": _vm.actionType,
          disabledView: _vm.disabledView
        },
        on: {
          objectTemplates: function($event) {
            return _vm.$emit("objectTemplates", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b82303a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b82303a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/WorkOrderDetails.vue
// module id = null
// module chunks = 